import React, { useState, useEffect } from "react";
import { Badge } from "@mantine/core";
import UniversalTable from "../Common/UniversalTable";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getActivityData } from "../../utilities/apis/recovery";
import { formatDate } from "../../utilities/utilities";

const ActivityComponent = ({ recoveryId }) => {
  const [activityData, setActivityData] = useState({
    actionActivity: [],
    finalApproval: [],
    approvalActivity: [],
  });
  const fetchDetails = async () => {
    const response = await apiWrapWithErrorWithData(
      getActivityData({ recoveryId })
    );
    if (response.success) {
      setActivityData((prevState) => ({
        ...prevState,
        actionActivity: response.data.actionAudit,
        finalApproval: response.data.approvalLogs,
        approvalActivity: response.data.approvalActivity,
      }));
    }
  };

  useEffect(() => {
    fetchDetails();
  }, [recoveryId]);

  const actionActivityTableHeaders = [
    { label: 'reference no.', key: 'actionId', render: (row) => `action-${row.actionId}` },
    { label: 'activity', key: 'isPaused', render: (row) => row.isPaused ? <Badge color="red">paused</Badge> : <Badge>unpaused</Badge> },
    { label: 'remark', key: 'remark' },
    { label: 'modified by', key: 'creatorName' },
    { label: 'date', key: 'createdAt', render: (row) => formatDate(row.createdAt) },
  ];

  const approvalActivityTableHeaders = [
    { label: 'sr no.', key: 'srNo', render: (_row, index) => index + 1 },
    { label: 'name', key: 'createdBy', render: (row) => row.createdBy?.name },
    { label: 'role', key: 'isNMI', render: (row) => row.isNMI ? <Badge>Editor</Badge> : <Badge>Initiator</Badge> },
    { label: 'comment', key: 'comment' },
    { label: 'date', key: 'createdAt', render: (row) => formatDate(row.createdAt) },
  ];

  const finalApprovalTableHeaders = [
    { label: 'sr no.', key: 'srNo', render: (_row, index) => index + 1 },
    { label: 'email', key: 'emailID' },
    { label: 'status', key: 'isApproved', render: (row) => row.isApproved ? <Badge color="green">Aprroved</Badge> : <Badge color="red">Rejected</Badge> },
    { label: 'date', key: 'createdAt', render: (row) => formatDate(row.createdAt) },
  ];

  return (
    <>
      <div className="m-10">
        <div className="font-normal text-[20px] leading-[1.55] text-black mb-5" style={{ color: '#1b6f8d"' }}>
          action activity
        </div>
        <UniversalTable
          headers={actionActivityTableHeaders}
          data={activityData.actionActivity}
          loading={false}
          emptyMessage="no data found"
        />
      </div>
      <div className="m-10">
        <div className="font-normal text-[20px] leading-[1.55] text-black mb-5" style={{ color: '#1b6f8d"' }}>
          approval activity
        </div>
        <UniversalTable
          headers={approvalActivityTableHeaders}
          data={activityData.approvalActivity}
          loading={false}
          emptyMessage="no data found"
        />
      </div>
      <div className="m-10">
        <div className="font-normal text-[20px] leading-[1.55] text-black mb-5" style={{ color: '#1b6f8d"' }}>
          final approval
        </div>
        <UniversalTable
          headers={finalApprovalTableHeaders}
          data={activityData.finalApproval}
          loading={false}
          emptyMessage="no data found"
        />
      </div>
    </>
  );
};

export default ActivityComponent;
